// extracted by mini-css-extract-plugin
export default {"userFullName":"users_userFullName__--eFu","companyName":"users_companyName__xzCLB","statusDateText":"users_statusDateText__-k48z"};